/** Canonical admin panel origin for links shared outside this deployment (app, email). */
export const ADMIN_PANEL_BASE_URL = 'https://admin.theoverhear.app';

/**
 * Base URL for admin deep links that must work from the mobile app / email.
 * Always uses the canonical production host (never localhost).
 */
export function getCanonicalAdminPanelBaseUrl(): string {
  return ADMIN_PANEL_BASE_URL;
}

/**
 * Base URL for share links meant for the current browser session.
 * Prefers the live origin except on localhost, where the canonical host is used.
 */
export function getAdminPanelBaseUrl(): string {
  if (typeof window !== 'undefined') {
    const origin = window.location?.origin;
    if (
      origin &&
      !origin.includes('localhost') &&
      !origin.includes('127.0.0.1')
    ) {
      return origin;
    }
  }
  return ADMIN_PANEL_BASE_URL;
}

/** Absolute admin URL that opens an organisational file. */
export function buildOrgFileAdminUrl(
  filePath: string,
  options?: { canonical?: boolean }
): string {
  const base = options?.canonical === false
    ? getAdminPanelBaseUrl()
    : getCanonicalAdminPanelBaseUrl();
  return `${base}/org-files?file=${encodeURIComponent(filePath)}`;
}
